export default "__VITE_ASSET__BIF0TKYn__"